import { useContext, useState, useEffect } from 'react';

import { DataContext } from 'providers/data';

import Typography from '@mui/material/Typography';

import { ContentCard, RiskGreen, ContentList, ContentPrice, Button } from './styles';

type ParamsPackageSingle = {
    title: string;
    price: string;
    VL_COMISSAO: number;
    nrTypeProduct: number;
    cdQuotationItem: string;
    codProductSingle: number;
    descriptionList: Array<string>;
    nR_PORCENTAGEM_INDENIZACAO: number;
}

const PackageCard = ({ title, price, descriptionList, codProductSingle, cdQuotationItem, nrTypeProduct, nR_PORCENTAGEM_INDENIZACAO }: ParamsPackageSingle) => {
    const [addToCart, setAddToCart] = useState(false);
    const { dataProductCart, handleProductCart } = useContext(DataContext);

    const handleService = () => {
        handleProductCart({
            bodyBase: {
                cD_COTACAO: 0,
                cD_PEDIDO: 0,
                customerId: 0,
            },
            body: {
                cD_COTACAO_ITEM: parseFloat(cdQuotationItem),
                cD_PRODUTO: codProductSingle,
                nM_PRODUTO: title,
                nR_TIPO_PRODUTO: nrTypeProduct,
                nR_PORCENTAGEM_INDENIZACAO: nR_PORCENTAGEM_INDENIZACAO,
                vL_TOTAL: `R$${price}`
            },
            addProduct: !addToCart,
            productPlan: false
        });
    }

    useEffect(() => {
        if (dataProductCart?.productAdd) {
            if (dataProductCart.productAdd?.findIndex(({ cD_PRODUTO }) => cD_PRODUTO === codProductSingle) > -1) {
                setAddToCart(true);
            } else {
                setAddToCart(false);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataProductCart]);

    return (
        <ContentCard>
            <div>
                <div>
                    <Typography fontSize='1.125rem' fontWeight={700} lineHeight='26px' textTransform='uppercase'>
                        {title.replace('Reparos -', '')}
                    </Typography>

                    <RiskGreen >
                        <div />
                        <span />
                    </RiskGreen>
                </div>

                <ContentList>
                    {descriptionList.map((value, index) => (
                        <li key={index}>
                            <Typography variant='body2' color='#003752' lineHeight='18px' fontWeight={400}>
                                + {value}
                            </Typography>
                        </li>
                    ))}
                </ContentList>
            </div>

            <ContentPrice>
                <Typography variant='h4' fontSize={32} fontWeight={700} color='primary.light' textTransform='capitalize'>
                    R$ {price}
                </Typography>

                <Button variant='contained' fullWidth handlebutton={addToCart ? 'remove' : 'add'} onClick={() => handleService()}>
                    {addToCart ? 'REMOVER' : 'ADICIONAR'}
                </Button>
            </ContentPrice>
        </ContentCard>
    )
}

export default PackageCard;